import { defineMessages } from "react-intl";
const messages = defineMessages({
    deviceNameTooltipTitle: {
        id: "app.sgt.unitSpaces.createAccessDevice.actions.createAccessDevice.name.tooltip.title",
        defaultMessage: "This will be displayed on the touring screen",
    },
});
export default messages;
